import { HttpContextToken } from '@angular/common/http';

export const SKIP_PROGRESS_BAR = new HttpContextToken<boolean>(() => false);
